import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from "environments/environment";
import { EventResponse } from "app/core/models/event-response";

@Injectable()
export class EventService {

  constructor(private readonly _httpClient: HttpClient) { }

  public getEvents(filter: string, sortDirection: 'asc' | 'desc'| '', sortField: string, 
                      pageIndex: number, pageSize: number, activeFilters: Object[]): Observable<EventResponse> {
    
    let allStringFilterAux = [];
    activeFilters.forEach((item, index) => {
      if (item['value'] != null && item['value'] != '') {
        let stringFilterAux = [item['id'],item['value']];
        allStringFilterAux.push(stringFilterAux.join('::'));
      }
    });

    let queryFilter = allStringFilterAux.join('--');

    
    let params = new HttpParams()
    .set('page', pageIndex.toString())
    .set('page_size', pageSize.toString())
    .set('sf', sortField?.toString() ? sortField?.toString() : '')
    .set('s', sortField?.toString() ? sortDirection?.toString().toUpperCase() : '')
    .set('f', queryFilter);

    return this._httpClient.get(`${environment.apiUrl}/ewan/events`, {
      params: params
      }).pipe(
          
          map(res =>  <EventResponse>res)
      );
  }

  getEventStatus(): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/ewan/events/status`);
  }

  getEventSource(): Observable < any > {
    return this._httpClient.get(`${environment.apiUrl}/ewan/events/source`);
}

  getEventsList(): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/ewan/events`);
  }

  getEvent(id: string): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/ewan/events/${id}`);
  }

  createEvent(event: any): Observable < any > {
      return this._httpClient.post(`${environment.apiUrl}/ewan/events`, event);
  }

  editEvent(event: any, id: string): Observable < any > {
      return this._httpClient.put(`${environment.apiUrl}/ewan/events/${id}`, event);
  }

  deleteEvent(id: string): Observable < any > {
      return this._httpClient.delete(`${environment.apiUrl}/ewan/events/${id}`);
  }
  
}
